// extracted by mini-css-extract-plugin
export var backdropBlur = "_m0-0";
export var contentCard = "_m0-5";
export var frame = "_m0-2";
export var image = "_m0-4";
export var imagePane = "_m0-3";
export var modal = "_m0-1";